import { Component, ViewChild, TemplateRef, Input, ElementRef, Renderer2, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { qmsService } from '../qms.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DynamicGridConfig, DynamicGridClauses, DynamicGridReport, DynamicGridSettings, DynamicGridTrail } from 'src/app/support/models/dynamic-grid.model';

export interface EcFindingPk {
  findingEcId?: number | null;
}

export interface EcFinding {
  qmsTaskEcFindingsVwPK?: EcFindingPk | null;
  ecId?: number | null;
  module?: string;
  refNo?: number | null;
  findingId?: number | null;
  finding?: string;
  methodology?: string;
  criteria?: string;
  conclusion?: string;
  createdOn?: string | Date | null;
  createdBy?: number | null;
  createdByUser?: string;
  updatedOn?: string | Date | null;
  updatedBy?: number | null;
  updatedByUser?: string;
  deleteReason?: string;
  userId?: number | null;
}

export const RESET_EC_FINDING: EcFinding = {
  qmsTaskEcFindingsVwPK: {
    findingEcId: null
  },
  ecId: null,
  module: '',
  refNo: null,
  findingId: null,
  finding: '',
  methodology: '',
  criteria: '',
  conclusion: '',
  createdOn: null,
  createdBy: null,
  createdByUser: '',
  updatedOn: null,
  updatedBy: null,
  updatedByUser: '',
  deleteReason: '',
  userId: null,
};


@Component({
  selector: 'app-tasks-ec-findings',
  templateUrl: './tasks-ec-findings.component.html',
  styleUrls: ['./tasks-ec-findings.component.scss']
})

export class TasksEcFindingsComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() ec: any = {};

  ecFinding: EcFinding;

  isProcessing = false;
  module: any;
  refNo: any;
  dateCustomClasses: DatepickerDateCustomClasses[];
  isFrozen: boolean = false;
  showConclusion: boolean = false;

  constructor(
    private readonly appService: AppService,
    private readonly snackBar: MatSnackBar,
    private readonly sanitizer: DomSanitizer,
    private readonly elem: ElementRef,
    private readonly renderer: Renderer2,
    readonly qualityService: qmsService,
    readonly dialog: MatDialog,
    readonly router: Router,
    readonly paginationService: PaginationService,
    readonly message: messageService,
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.module = this.qualityService.moduleName;
    this.refNo = this.message.ecMasterDetails.REF_NO;
  }

  findingsList: any = [];
  methodologyList: any = [];

  findingsDropdown: any = [];
  methodologyDropdown: any = [];

  findingSearchText: string = '';
  methodologySearchText: string = '';

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.isFrozen = this.ec.showSubTaskButtons;
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("AU_EFFECTIVENESS_CHECK_METHODOLOGY").subscribe((data: any) => {
      this.methodologyList = data;
      this.selectBoxForMethodology();

      this.appService.getAllAuFindingsByAuNo(this.refNo).subscribe((findings: any) => {
        this.findingsList = findings;
        this.isProcessing = false;
        this.selectBoxForFindings();
      });
    });

    this.getDynamicLabel();
    this.getCall();

    this.ecFinding = { ...RESET_EC_FINDING };
    this.showConclusion = this.ec.status == 'QA Approval Rejected' || this.ec.status == 'In Progress';
  }

  snackbarRef: any;
  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  groupSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value); searchBox?.focus();
    }, 0)
  }

  private selectBoxForMethodology(): void {
    this.methodologyDropdown = this.methodologyList?.map((docType: any) => ({
      valueExp: docType.codelistCode,
      displayExp: docType.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  public onMethodologySelect(event: any, item: any): void {
    if (event.isUserInput) {
      setTimeout(() => {
        this.handleDropDownValidation('methodology', item.valueExp);
      })
    }
  }

  public selectBoxForFindings(): void {
    this.findingsDropdown = this.findingsList?.map((finding: any) => ({
      valueExp: finding.findingId,
      displayExp: finding.findingShortDescription
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  public onFindingSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.handleDropDownValidation('finding', item.valueExp);
      })
    }
  }

  public onNgModelChange(items: any, fieldId: string): void {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. [onNgModuleChange()] Id → ', fieldId);
  }

  public handleDropDownValidation(fieldId: string, selectedItems: any[] | string): void {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = fieldId == 'business-area';
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  gridConfig: DynamicGridConfig = {} as any;
  gridClause: DynamicGridClauses = {};
  gridTrail: DynamicGridTrail = {} as any;
  gridReport: DynamicGridReport = {} as any;
  gridSettings: DynamicGridSettings = {} as any;
  idMapping: Record<string, string> = { 'CR': this?.qualityService?.activity?.crId, 'CAPA': this.qualityService.activity.capaId, 'DV': this.qualityService.activity.dvId, 'AU': this.qualityService.activity.auId, 'IN': this.qualityService.activity.inId, 'QI': this.qualityService.activity.qiId, 'CC': this.qualityService.activity.ccId };

  getCall() {
    this.gridConfig = {
      ...this.gridConfig,
      gridName: 'EC_FINDING',
      groupId: 0,
      showAddButton: !this.isFrozen,
      showEditIcon: !this.isFrozen,
      showDeleteIcon: !this.isFrozen,
      showAuditTrail: true,
      showReorderButton: false,
      buttonsTooltipSubName: 'EC Findings',
    }

    this.gridClause = {
      ...this.gridClause,
      refNo: this.qualityService.activityId,
      ecIdFromECMasterPage: this.message.ecMasterDetails.EC_ID,
    }

    this.gridTrail = {
      ...this.gridTrail,
      gridName: "EC_FINDING",
      refKey: 'FINDING_EC_ID',
      trailName: this.qualityService.moduleName + ' EC Findings Audit Trail [' + this.idMapping[this.qualityService.moduleName] + ']'
    }

    this.gridReport = {
      ...this.gridReport,
      reportName: this.qualityService.moduleName + ' EC Findings Report [' + this.idMapping[this.qualityService.moduleName] + ']',
      reportType: 'Dynamic',
      excludeGroupId: true,
    }

    this.gridSettings = {
      ...this.gridSettings,
      module: this.qualityService.moduleName,
      groupId: 0
    }
  }

  public onAddEmit(): void {
    this.openAddPopup();
  }

  public onEditEmit(event: { mode: string; id: number; obj: any }): void {
    this.openEditPopup(event.obj, event.id, event.mode);
  }

  public onDeleteEmit(event: any): void {
    this.openDeletePopup(event);
  }

  popupTitle: string | null = 'title';

  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;

  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  operationFlag: any;
  openAddPopup() {
    this.popupTitle = "Create Effectiveness Check Findings";
    this.ecFinding = { ...RESET_EC_FINDING };
    this.operationFlag = 'ADD';
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  editingEcFinding: any = {};
  openEditPopup(data: any, id: any, mode: string) {
    if (id == 0 || id == 1) {
      this.popupTitle = mode == 'edit' ? "Edit Effectiveness Check Finding" : 'View Effectiveness Check Finding';
      this.operationFlag = 'EDIT';
      this.editingEcFinding = data;
      this.isProcessing = true;
      this.appService.getEcFindingsById(this.refNo, data.EC_ID, data.FINDING_EC_ID).subscribe((response: any) => {
        this.ecFinding = response;
        this.isProcessing = false;
        this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
      })
    }
  }

  deletingEcFinding: any = {};
  openDeletePopup(data: any) {
    this.popupTitle = "Delete Effectiveness Check Findings";
    this.operationFlag = 'DELETE';
    this.deletingEcFinding = data;
    this.ecFinding.deleteReason = "";
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  cancelAddAndEditPopup() {
    this.visibleAddAndEditPopup.close();
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  isContentEmpty(content: string): boolean {
    // Create a temporary element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Get the text content and trim it
    const textContent = (tempDiv.textContent ?? tempDiv.innerText) || '';
    return textContent.trim().length === 0;
  }

  public mandatoryValidation(elementIds: any): void {
    for (const elementId of elementIds) {
      const element = document.getElementById(elementId) as HTMLInputElement | null;
      if (element) {
        element.style.color = 'red';
      } else {
        console.error('Unable to find the element. [onNgModuleChange()] Id → ', element);
      }
    }
  }

  addAndEditFunction(ecFindings: EcFinding) {
    const validations: any[] = [
      { condition: !this.ecFinding.findingId, id: 'finding' },
      { condition: !this.ecFinding.methodology, id: 'methodology' },
      { condition: !this.ecFinding.criteria, id: 'criteria' },
      { condition: this.ec.status == 'In Progress' && (!this.ecFinding.conclusion || this.isContentEmpty(this.ecFinding.conclusion)), id: 'conclusion' }
    ]
    const invalidIds = validations.filter(v => v.condition).map(v => v.id);
    if (invalidIds.length > 0) {
      setTimeout(() => {
        this.mandatoryValidation(invalidIds);
        this.showSnackBar('Please enter all mandatory fields', 'E');
      })
      this.isProcessing = false;
      return false;
    } else if (this.operationFlag == 'ADD') {
      return this.add(ecFindings);
    } else if (this.operationFlag == 'EDIT') {
      return this.edit(ecFindings);
    }
  }

  private add(ecFinding: EcFinding): void {

    const obj: EcFinding = {
      ecId: this.message.ecMasterDetails.EC_ID,
      module: this.module,
      refNo: this.refNo,
      findingId: ecFinding.findingId,
      methodology: ecFinding.methodology,
      criteria: ecFinding.criteria,
      conclusion: ecFinding.conclusion,
    }

    this.isProcessing = true;
    this.appService.createEcFindings(obj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.getCall();
          this.isProcessing = false;
          this.visibleAddAndEditPopup.close();
          this.showSnackBar(Response.result, Response.resultType);
        } else {
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  private edit(ecFinding: EcFinding): void {

    const obj: EcFinding = {
      qmsTaskEcFindingsVwPK: {
        findingEcId: this.editingEcFinding.FINDING_EC_ID
      },
      ecId: this.message.ecMasterDetails.EC_ID,
      module: this.module,
      refNo: this.refNo,
      findingId: ecFinding.findingId,
      methodology: ecFinding.methodology,
      criteria: ecFinding.criteria,
      conclusion: ecFinding.conclusion,
    }

    this.isProcessing = true;
    this.appService.updateEcFindings(obj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.getCall();
          this.isProcessing = false;
          this.visibleAddAndEditPopup.close();
          this.showSnackBar(Response.result, Response.resultType);
        } else {
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  deleteFunction(ecFinding: EcFinding) {

    if (!this.ecFinding.deleteReason) {
      const field = document.getElementById('delete-reason') as HTMLInputElement;
      field.style.color = 'red';
      this.showSnackBar('Please enter the delete reason', 'E');
      return;
    }

    const obj: EcFinding = {
      qmsTaskEcFindingsVwPK: {
        findingEcId: this.deletingEcFinding.FINDING_EC_ID
      },
      ecId: this.message.ecMasterDetails.EC_ID,
      module: this.module,
      refNo: this.refNo,
      deleteReason: ecFinding.deleteReason,
    }

    this.isProcessing = true;
    this.appService.deleteEcFindings(obj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.getCall();
          this.visibleDeletePopup.close();
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        } else {
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });

  }

  private showSnackBar(message: string, type: string): void {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe({
      next: () => {
        this.snackbarRef.dismiss();
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      },
    })
  }

  label: any = [];
  dynamicLabel: any = null;
  private getDynamicLabel(): void {
    this.isProcessing = true;
    const data = {
      tableName: 'QMS_TASK_FINDING_EC_VW',
      moduleName: this.qualityService.moduleName,
      gridName: 'EC_FINDING',
      groupId: this.qualityService.selectedGroup,
      forLabel: "Y"
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }


  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  excludeButtons: EditorConfig = {
    buttons: [],
  };

  includeButtons: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  editorValue: any;
  public openEditor(value: string, icon: string): void {

    const editorTitleMapping: Record<string, any> = {
      'Criteria': this.dynamicLabel?.['CRITERIA'],
      'Conclusion': this.dynamicLabel?.['CONCLUSION'],
    };

    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.ecFinding[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.ecFinding[this.getModel(this.editorName)] = editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): keyof EcFinding {
    const model = value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join('');

    return model as keyof EcFinding;
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };


}
